import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-183a400f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Employee Details\n          ")
], -1));
const _hoisted_4 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Does the employee have an I.T. account? *\n            ", -1));
const _hoisted_6 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_7 = { class: "mt-4 space-y-4" };
const _hoisted_8 = { class: "flex items-start" };
const _hoisted_9 = { class: "h-5 flex items-center" };
const _hoisted_10 = ["checked", "disabled"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "itAccount",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_12 = { class: "flex items-start" };
const _hoisted_13 = { class: "h-5 flex items-center" };
const _hoisted_14 = ["checked", "disabled"];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "itAccount",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_16 = { class: "col-span-6" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employeeName",
    class: "block text-sm font-medium text-gray-700"
}, "Employee's full name *", -1));
const _hoisted_18 = ["value", "disabled"];
const _hoisted_19 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_20 = { class: "col-span-6" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employeeNumber",
    class: "block text-sm font-medium text-gray-700"
}, "Employee number *", -1));
const _hoisted_22 = ["value", "disabled"];
const _hoisted_23 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_24 = { class: "col-span-6" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "division",
    class: "block text-sm font-medium text-gray-700"
}, "Division *", -1));
const _hoisted_26 = ["value", "disabled"];
const _hoisted_27 = ["value"];
const _hoisted_28 = ["value"];
const _hoisted_29 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_30 = { class: "col-span-6" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "v",
    class: "block text-sm font-medium text-gray-700"
}, "Company Code *", -1));
const _hoisted_32 = ["value", "disabled"];
const _hoisted_33 = ["value"];
const _hoisted_34 = ["value"];
const _hoisted_35 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_36 = { class: "col-span-6" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "sector_code",
    class: "block text-sm font-medium text-gray-700"
}, "Sector *", -1));
const _hoisted_38 = ["value", "disabled"];
const _hoisted_39 = ["value"];
const _hoisted_40 = ["value"];
const _hoisted_41 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_42 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_43 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("fieldset", null, [
                        _hoisted_5,
                        _createTextVNode(),
                        (_ctx.v$.formData.itAccount.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "\n              * " + _toDisplayString(_ctx.v$.formData.itAccount.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("input", {
                                            id: "itAccount-yes",
                                            value: "Yes",
                                            name: "itAccount",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.itAccount === 'Yes',
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[0] || (_cache[0] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.itAccount.$touch()))
                                        }, null, 40, _hoisted_10)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_11
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("input", {
                                            id: "itAccount-no",
                                            value: "No",
                                            name: "itAccount",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            checked: _ctx.formData.itAccount === 'No',
                                            disabled: _ctx.disableForm,
                                            onChange: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.itAccount.$touch()))
                                        }, null, 40, _hoisted_14)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_15
                                ])
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(),
                    _createElementVNode("input", {
                        id: "employee-name-input",
                        value: _ctx.formData.employeeName,
                        disabled: _ctx.disableForm,
                        type: "text",
                        name: "employeeName",
                        autocomplete: "name",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                'error-border': _ctx.v$.formData.employeeName.$error,
                                'border-red-500': _ctx.v$.formData.employeeName.$error,
                            }]),
                        onInput: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.employeeName.$touch()))
                    }, null, 42, _hoisted_18),
                    _createTextVNode(),
                    (_ctx.v$.formData.employeeName.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "\n            * " + _toDisplayString(_ctx.v$.formData.employeeName.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(),
                    _createElementVNode("input", {
                        id: "employee-number-input",
                        value: _ctx.formData.employeeNumber,
                        disabled: _ctx.disableForm,
                        type: "text",
                        name: "employeeNumber",
                        autocomplete: "name",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                'error-border': _ctx.v$.formData.employeeNumber.$error,
                                'border-red-500': _ctx.v$.formData.employeeNumber.$error,
                            }]),
                        onInput: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.employeeNumber.$touch()))
                    }, null, 42, _hoisted_22),
                    _createTextVNode(),
                    (_ctx.v$.formData.employeeNumber.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "\n            * " + _toDisplayString(_ctx.v$.formData.employeeNumber.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createTextVNode(),
                    _createElementVNode("select", {
                        id: "division",
                        name: "division",
                        autocomplete: "division",
                        value: _ctx.formData.division,
                        disabled: _ctx.disableForm,
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed", {
                                'error-border': _ctx.v$.formData.division.$error,
                                'border-red-500': _ctx.v$.formData.division.$error,
                            }]),
                        onChange: _cache[8] || (_cache[8] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.division.$touch()))
                    }, [
                        (_ctx.disableForm)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems.DIVISIONS, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.ID,
                                    value: item.NAME
                                }, _toDisplayString(item.NAME), 9, _hoisted_27));
                            }), 128))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeDivisions, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.ID,
                                    value: item.NAME
                                }, _toDisplayString(item.NAME), 9, _hoisted_28));
                            }), 128))
                    ], 42, _hoisted_26),
                    _createTextVNode(),
                    (_ctx.v$.formData.division.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "\n            * " + _toDisplayString(_ctx.v$.formData.division.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createTextVNode(),
                    _createElementVNode("select", {
                        id: "company_code",
                        name: "company_code",
                        autocomplete: "company_code",
                        value: _ctx.formData.company_code,
                        disabled: _ctx.disableForm,
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed", {
                                'error-border': _ctx.v$.formData.company_code.$error,
                                'border-red-500': _ctx.v$.formData.company_code.$error,
                            }]),
                        onChange: _cache[10] || (_cache[10] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.company_code.$touch()))
                    }, [
                        (_ctx.disableForm)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems?.ENTITIES, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.entity,
                                    value: item.entity
                                }, _toDisplayString(item.entity), 9, _hoisted_33));
                            }), 128))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeEntities, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.entity,
                                    value: item.entity
                                }, _toDisplayString(item.entity), 9, _hoisted_34));
                            }), 128))
                    ], 42, _hoisted_32),
                    _createTextVNode(),
                    (_ctx.v$.formData.company_code.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "\n            * " + _toDisplayString(_ctx.v$.formData.company_code.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createTextVNode(),
                    _createElementVNode("select", {
                        id: "sector_code",
                        name: "sector_code",
                        autocomplete: "sector_code",
                        value: _ctx.formData.sector_code,
                        disabled: _ctx.disableForm,
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed", {
                                'error-border': _ctx.v$.formData.sector_code.$error,
                                'border-red-500': _ctx.v$.formData.sector_code.$error,
                            }]),
                        onChange: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.sector_code.$touch()))
                    }, [
                        (_ctx.disableForm)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentDivision?.SECTORS, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.ID,
                                    value: item.NAME
                                }, _toDisplayString(item.NAME), 9, _hoisted_39));
                            }), 128))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeSectors, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.ID,
                                    value: item.NAME
                                }, _toDisplayString(item.NAME), 9, _hoisted_40));
                            }), 128))
                    ], 42, _hoisted_38),
                    _createTextVNode(),
                    (_ctx.v$.formData.sector_code.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "\n            * " + _toDisplayString(_ctx.v$.formData.sector_code.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSaveForm && _ctx.handleSaveForm(...args)), ["prevent"]))
                    }, "\n          Next\n        ", 8, _hoisted_43)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
